import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getCurrentSituation = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CURRENT_SITUATION,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Situacion_Actual/' : '/api/app/Funcional_Situacion_Actual/', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_CURRENT_SITUATION,
      payload: {
        currentSituation: resp.data.data,
        currentSituationLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_CURRENT_SITUATION,
      payload: false
    });
  }
}

export const saveCurrentSituation = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CURRENT_SITUATION,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Situacion_Actual/' : '/api/app/Funcional_Situacion_Actual/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { currentSituation, currentSituationLength } = getState().currentSituation;
    const aCurrentSituation = [...currentSituation, resp.data];
    dispatch({
      type: actions.GET_CURRENT_SITUATION,
      payload: {
        currentSituation: aCurrentSituation,
        currentSituationLength: currentSituationLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_CURRENT_SITUATION,
      payload: false
    });
  }
}

export const editCurrentSituation = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CURRENT_SITUATION,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Situacion_Actual/${id}/` :`/api/app/Funcional_Situacion_Actual/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { currentSituation, currentSituationLength } = getState().currentSituation;
    currentSituation[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_CURRENT_SITUATION,
      payload: {
        currentSituation: currentSituation,
        currentSituationLength: currentSituationLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_CURRENT_SITUATION,
      payload: false
    });
  }
}

export const deleteCurrentSituation = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CURRENT_SITUATION,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Situacion_Actual/${id}/` : `/api/app/Funcional_Situacion_Actual/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { currentSituation, currentSituationLength } = getState().currentSituation;
    currentSituation.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_CURRENT_SITUATION,
      payload: {
        currentSituation: currentSituation,
        currentSituationLength: currentSituationLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_CURRENT_SITUATION,
      payload: false
    });
  }
}
